import { learnerBootstrapSchema } from '@mio/shared';
import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '@/shared/api/client';

/** The cache key other features patch after a profile change, such as finishing placement. */
export const bootstrapQueryKey = (learnerId: string | null) =>
  ['learner', learnerId, 'bootstrap'] as const;

/** Idempotent setup, cached for this authenticated account's application session. */
export function useBootstrap(learnerId: string | null) {
  return useQuery({
    queryKey: bootstrapQueryKey(learnerId),
    enabled: learnerId !== null,
    staleTime: Infinity,
    retry: 1,
    queryFn: async ({ signal }) => {
      const result = await apiRequest('/me/bootstrap', learnerBootstrapSchema, {
        method: 'POST',
        signal,
      });
      if (result.learner.id !== learnerId)
        throw new Error('Your account changed. Please sign in again.');
      return result;
    },
  });
}
